import { Root } from './components/Root';
import { Item } from './components/Item';

export const StepsController = {
  Root,
  Item,
};
